<template>
    <RadioGroup v-model="checked" @on-change="onChange" size="small">
        <Radio v-for="(item,index) in data" :key="index" :label="item.value">
            <span>{{item.label}}</span>
        </Radio>
    </RadioGroup>
</template>
<script>
export default {
    name: 'radio-prop',
    props:["data","value"],
    data() {
        return {
            checked:''
        }
    },
    watch: {
        'value':{
            handler(){
                this.checked = this.value;
            },
            immediate:true
        }
    },
    methods: {
        onChange(){
            this.$emit('input',this.checked)
            this.$emit('save')
        }
    },
}
</script>